/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Group_NotificationsInputs */

const en_settings_group_notifications = /** @type {(inputs: Settings_Group_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications & Shortcut`)
};

const de_settings_group_notifications = /** @type {(inputs: Settings_Group_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitteilungen & Kurzbefehl`)
};

/**
* | output |
* | --- |
* | "Notifications & Shortcut" |
*
* @param {Settings_Group_NotificationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_group_notifications = /** @type {((inputs?: Settings_Group_NotificationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Group_NotificationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_group_notifications(inputs)
	return en_settings_group_notifications(inputs)
});